var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167969 8.46605C0.167969 3.83494 4.03796 0.0917969 8.71911 0.0917969C13.4135 0.0917969 17.2834 3.83494 17.2834 8.46605C17.2834 10.7997 16.4347 12.9663 15.0378 14.8026C13.4967 16.8282 11.5972 18.5931 9.4592 19.9784C8.96987 20.2985 8.52825 20.3227 7.9912 19.9784C5.84098 18.5931 3.94152 16.8282 2.41362 14.8026C1.01567 12.9663 0.167969 10.7997 0.167969 8.46605ZM5.90248 8.72631C5.90248 10.2777 7.16845 11.4979 8.72071 11.4979C10.274 11.4979 11.5521 10.2777 11.5521 8.72631C11.5521 7.18697 10.274 5.90737 8.72071 5.90737C7.16845 5.90737 5.90248 7.18697 5.90248 8.72631Z",
    fill: "#DB3251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.5d7d82d575823b1261e9d34ba6857231.svg";
export { ForwardRef as ReactComponent };